<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading
                :active.sync="isLoading"
                :is-full-page="fullPage"
            ></loading>
        </div>

        <breadcrumb
            :page="$t('form.gradingScales.createGradingScale')"
        ></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert
                    v-model="alert"
                    :variant="alertClass"
                    dismissible
                    fade
                    >{{ alertMessage }}</b-alert
                >

                <form role="form" @submit.prevent="submit()">
                    <div class="card">
                        <div class="card-header bg-light">
                            <div class="card-title">
                                {{
                                    $t("form.gradingScales.createGradingScale")
                                }}
                            </div>
                            <b-button
                                type="submit"
                                variant="primary"
                                class="float-right"
                                >{{ $t("button.save") }}</b-button
                            >
                        </div>

                        <div
                            class="card-body"
                            v-for="(gradingScale, tabIndex) in gradingScales"
                            :key="tabIndex"
                        >
                            <div class="form-group">
                                <label>{{
                                    $t("form.gradingScales.name")
                                }}</label>
                                <input
                                    v-model="gradingScale.name"
                                    type="text"
                                    class="form-control"
                                />
                            </div>
                            <div class="form-group">
                                <label>{{ $t("form.gradingScales.gradingScaleType") }} <span class="text-danger">*</span></label>
                                <v-select label="name" :reduce="t => Number(t.id)"
                                    v-model="gradingScale.grading_scale_type_id"
                                    :options="gradingScaleTypes"
                                ></v-select>
                            </div>
                            <div class="form-group">
                                <label>{{
                                    $t("form.gradingScales.programCode")
                                }}</label>
                                <v-select
                                    v-model="gradingScale.program_code"
                                    :options="programCodes"
                                    multiple
                                ></v-select>
                            </div>
                            <div class="form-group">
                                <label class="checkbox">
                                    <input
                                        type="checkbox"
                                        value="0"
                                        v-model="
                                            gradingScale.local_grading_scale
                                        "
                                    />
                                    {{
                                        $t(
                                            "form.gradingScales.localGradingScale"
                                        )
                                    }}
                                </label>
                            </div>
                            <div
                                class="form-group"
                                v-if="gradingScale.local_grading_scale"
                            >
                                <label>{{
                                    $t("form.gradingScales.partnerCode")
                                }}</label>
                                <v-select
                                    label="PartnerCode"
                                    :options="partnerCodes"
                                    v-model="gradingScale.partner_code"
                                    multiple
                                ></v-select>
                            </div>
                            <div
                                class="form-group"
                                v-if="gradingScale.local_grading_scale"
                            >
                                <label>{{
                                    $t("form.gradingScales.localGradeName")
                                }}</label>
                                <input
                                    v-model="gradingScale.local_grade_name"
                                    type="text"
                                    class="form-control"
                                />
                            </div>
                            <div
                                class="form-group"
                                v-if="gradingScale.local_grading_scale"
                            >
                                <label>{{
                                    $t("form.gradingScales.minimumGrade")
                                }}</label>
                                <input
                                    v-model="gradingScale.minimum_grade"
                                    type="text"
                                    class="form-control"
                                />
                            </div>
                            <div
                                class="form-group"
                                v-if="gradingScale.local_grading_scale"
                            >
                                <label>{{
                                    $t("form.gradingScales.maximumGrade")
                                }}</label>
                                <input
                                    v-model="gradingScale.maximum_grade"
                                    type="text"
                                    class="form-control"
                                />
                            </div>

                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th
                                            v-if="
                                                !gradingScale.local_grading_scale
                                            "
                                        >
                                            {{
                                                $t(
                                                    "form.gradingScales.descGrade"
                                                )
                                            }}
                                        </th>
                                        <th
                                            v-if="
                                                !gradingScale.local_grading_scale
                                            "
                                        >
                                            {{
                                                $t(
                                                    "form.gradingScales.ectsGrade"
                                                )
                                            }}
                                        </th>
                                        <th>
                                            {{ $t("form.gradingScales.grade") }}
                                        </th>
                                        <th>
                                            {{
                                                $t(
                                                    "form.gradingScales.maxPercentage"
                                                )
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                $t(
                                                    "form.gradingScales.minPercentage"
                                                )
                                            }}
                                        </th>
                                        <th class="text-right">
                                            <b-button
                                                @click="
                                                    addGradingScaleCondition(
                                                        tabIndex
                                                    )
                                                "
                                                :title="$t('button.new')"
                                            >
                                                <i
                                                    class="fas fa-plus-circle"
                                                ></i>
                                            </b-button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(
                                            item, index
                                        ) in gradingScale.grading_scale"
                                        :key="index"
                                    >
                                        <td
                                            v-if="
                                                !gradingScale.local_grading_scale
                                            "
                                        >
                                            <b-form-select
                                                v-model="item.descGrade"
                                                :options="descGrades"
                                            >
                                            </b-form-select>
                                        </td>
                                        <td
                                            v-if="
                                                !gradingScale.local_grading_scale
                                            "
                                        >
                                            <b-form-select
                                                v-model="item.ectsGrade"
                                                :options="ectsGrades"
                                            >
                                            </b-form-select>
                                        </td>
                                        <td>
                                            <b-form-input
                                                v-model="item.grade"
                                            ></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input
                                                v-model="item.maxPercentage"
                                            ></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input
                                                v-model="item.minPercentage"
                                            ></b-form-input>
                                        </td>
                                        <td class="text-right">
                                            <b-button
                                                variant="danger"
                                                @click="
                                                    removeGradingScaleCondition(
                                                        tabIndex,
                                                        index
                                                    )
                                                "
                                                :title="$t('button.remove')"
                                            >
                                                <i
                                                    class="fas fa-minus-circle"
                                                ></i>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["permissions"],

    data() {
        return {
            alert: false,
            alertClass: null,
            alertMessage: null,

            isLoading: false,
            fullPage: true,
            partner_id: null,

            gradingScaleTypes: [],
            gradingScales: [
                {
                    name: "",
                    grading_scale_type_id: null,
                    local_grading_scale: 0,
                    local_grade_name: "",
                    minimum_grade: "1.0",
                    maximum_grade: "6.0",
                    partner_code: [],
                    program_code: [],
                    grading_scale: [],
                },
            ],
            programCodes: [],
            partnerCodes: [],
            descGrades: [],
            ectsGrades: [],
        };
    },

    mounted() {
        if (!this.permissions.viewSettingsGradingscale) {
            return this.$router.push("/");
        }

        this.getInitialData();
    },

    methods: {
        /**
         * Fetch initial data for grading scale
         */
        getInitialData() {
            axios.get("/api/settings/initial-data").then((response) => {
                this.descGrades = response.data.descGrades;
                this.ectsGrades = response.data.ectsGrades;
                this.programCodes = response.data.programCodes;
                this.partnerCodes = response.data.partnerCodes;
                this.gradingScaleTypes = response.data.gradingScaleTypes;
                const def = this.gradingScaleTypes.find(
                    t => t.code === "SBS_STANDARD" || t.name === "SBS Standard"
                );
                if (def && !this.gradingScales[0].grading_scale_type_id) {
                    this.gradingScales[0].grading_scale_type_id = Number(def.id);
                }
            });
        },

        /**
         * Add condition in grading scale
         *
         * @param int index of questioning grading scale list
         */
        addGradingScaleCondition(index) {
            this.gradingScales[index].grading_scale.push({
                descGrade: null,
                ectsGrade: null,
                grade: null,
                maxPercentage: null,
                minPercentage: null,
            });
        },

        /**
         * Remove condition from grading scale
         *
         * @param int index of questioning grading scale
         * @param int index of questioning condition under grading scale
         */
        removeGradingScaleCondition(tabIndex, index) {
            if (confirm(this.$t("form.validation.delete")) !== false) {
                this.gradingScales[tabIndex].grading_scale.splice(index, 1);
            }
        },

        /**
         * Save grading scale
         */
        submit() {
            if (this.gradingScales.length === 0) {
                alert(this.$t("form.setting.noGradingScale"));
                return;
            }

            this.isLoading = true;

            axios
                .post("/api/grading-scales", this.gradingScales[0])
                .then((response) => {
                    this.isLoading = false;

                    if (response.data.success) {
                        this.showAlert(response.data.message);

                        setTimeout(() => {
                            this.$router.push({
                                name: "GradingScaleIndex",
                            });
                        }, 2000);
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.showAlert(error.response.data.message, "danger");
                });
        },

        /**
         * Display alert or notification
         */
        showAlert(msg, cls = "success") {
            this.alertMessage = msg;
            this.alertClass = cls;
            this.alert = true;
        },
    },
};
</script>
